import { tr, localizedStatic } from "@/i18n/copy";
export const SETUP_STEPS = localizedStatic([
  { id: "profile", title: "Il tuo Studio" },
  { id: "branding", title: "Identità" },
  { id: "settings", title: "Impostazioni" },
  { id: "documents", title: "Documenti" },
  { id: "team", title: "Team" },
  { id: "confirm", title: "Conferma" },
], [[0,"title"],[1,"title"],[2,"title"],[3,"title"],[4,"title"],[5,"title"]]);

export function setupStepIndex(value) {
  if (typeof value !== "string" || !value) return 0;
  const index = SETUP_STEPS.findIndex((item) => item.id === value);
  return index >= 0 ? index : 0;
}

export function setupStepAt(index) {
  return SETUP_STEPS[Number.isInteger(index) && index >= 0 && index < SETUP_STEPS.length ? index : 0];
}

export function setupNeedsAttention(setup) {
  const readiness = setup?.onboarding?.readiness;
  if (!readiness || typeof readiness !== "object") {
    return ["profile_configured", "branding_configured", "documents_configured", "team_configured"];
  }
  return Object.entries(readiness).filter(([, ready]) => !ready).map(([step]) => step);
}

export function shouldGuideOwnerToSetup(setup) {
  return Boolean(setup && !setup.onboarding?.completed && !setup.onboarding?.legacy);
}
